import { gql } from '@apollo/client';

export type SaveExternalStationInput = {
  id?: number;
  name: string;
  sortingCode: string;
  carrierCode?: number | null;
  addressName: string;
  stationType?: number | null;
  addressLine1: string;
  addressLine2?: string | null;
  contactName?: string | null;
  phoneNumber?: string | null;
  timezoneLocation: string;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  zipcode?: string | null;
  temuWarehouseId?: string | null;
  isTest?: boolean;
};

export const SAVE_EXTERNAL_STATION = gql`
  mutation SaveExternalStation($input: SaveExternalStationInput!) {
    saveExternalStation(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_EXTERNAL_STATION = gql`
  mutation DeleteExternalStation($id: Long!) {
    deleteExternalStation(id: $id)
  }
`;

export const RESTORE_EXTERNAL_STATION = gql`
  mutation RestoreExternalStation($id: Long!) {
    restoreExternalStation(id: $id)
  }
`;
